import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EstacaoGrupoService } from 'src/services/estacao-grupos.service';
import { EstacaoService } from 'src/services/estacao.service';
import { PermissoesService } from 'src/services/permissoes.service';

@Component({
    selector: 'app-grupo-estacao-formulario',
    templateUrl: './grupo-estacao-formulario.component.html',
    styleUrls: ['./grupo-estacao-formulario.component.scss'],
    standalone: false
})
export class GrupoEstacaoFormularioComponent {
  array_estacoes: any[] = []
  dropDownEstacoes: any[] = []
  data: any[] = []
  estacoesSelecionadas: any[] = []
  displayModal: boolean = false
  loading: boolean = false
  form: FormGroup;
  @Output() onSave: EventEmitter<any> = new EventEmitter();
  constructor(
    protected _estacaoService: EstacaoService,
    protected _formBuilder: FormBuilder,
    protected permissaoService: PermissoesService,
    protected estacaoGrupoService: EstacaoGrupoService,
  ) { }

  ngOnInit(): void {
    this.form = this._formBuilder.group({
      id: [null],
      nome: [null],
      ativo: [null],
    })
    this.listEstacoes()
    this.index()
  }

  index(){
    this.estacaoGrupoService.index().subscribe(json => {
      this.data = json
    })
  }

  changeSelecionados(){
    console.log('estacoesSelecionadas', this.estacoesSelecionadas)
  }

  listEstacoes(): void {
    this._estacaoService.lookup().subscribe(json => {
      this.dropDownEstacoes = [
        ...json.map(item => ({
          value: item.id,
          label: item.descricao
        }))
      ];
    });
  }

  edit(event){
    this.array_estacoes = []
    this.form.reset()
    this.estacaoGrupoService.show(event.id).subscribe(json =>{
      this.form.patchValue(json)
      if(json.estacoes){
        json.estacoes.map(item => {
          this.array_estacoes.push({
            estacao_id: item.id
          })
        })
      }
      this.displayModal = true
    })

  }
  
  openNew(){
    this.array_estacoes = []
    this.form.reset()
    this.form.get('ativo').setValue(true)
this.displayModal = true

  }

  addEstacao(){
    this.array_estacoes.push({
      estacao_id: null
    })
  }

  removeEstacao(event) {
    this.array_estacoes = this.array_estacoes.filter(x => { return x !== event });
  }

  save(){
    let form = this.form.value
    let params = form
params.estacaoList = this.array_estacoes
this.estacaoGrupoService.save(params, form.id).subscribe(json => {
  this.index()
  this.displayModal = false
  this.onSave.emit()
}, err => {

})
  }
}
